import { render } from "./ActionCenterTab.vue?vue&type=template&id=6af70618&scoped=true"
import script from "./ActionCenterTab.vue?vue&type=script&lang=js"
export * from "./ActionCenterTab.vue?vue&type=script&lang=js"

import "./ActionCenterTab.vue?vue&type=style&index=0&id=6af70618&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af70618"]])

export default __exports__